<template>
  <footer class="py-4 footer mt-auto bg-light border-top">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-between">
        <!-- Company Info -->
        <div class="col-lg-6 mb-3 mb-lg-0">
          <div 
            class="d-flex align-items-center"
            :class="store.state.isRTL ? 'justify-content-lg-end' : 'justify-content-lg-start justify-content-center'"
          >
            <!-- TerraSense Logo -->
            <img 
              src="@/assets/img/logos/terrasense_logo.svg" 
              alt="TerraSense" 
              height="24" 
              class="me-2"
            >
            <div class="text-sm">
              <div class="fw-bold text-success">TerraSense</div>
              <div class="text-muted small">
                © {{ new Date().getFullYear() }} TerraSense Green Technology
              </div>
            </div>
          </div>
        </div>

        <!-- Support Contact Section -->
        <div class="col-lg-6">
          <div class="d-flex flex-wrap w-100 justify-content-lg-end justify-content-center">
            <span class="text-muted small">
              For any problem contact <a href="mailto:terrasenseag@gmail.com" class="text-success fw-semibold">terrasenseag@gmail.com</a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { useStore } from "vuex";

const store = useStore();
</script>

<style scoped>
.footer {
  background-color: var(--surface);
  border-top: 1px solid var(--border-color);
  margin-top: auto;
}

.hover-text-success:hover {
  color: var(--primary-color) !important;
  transition: color 0.2s ease;
}

.text-success {
  color: var(--primary-color) !important;
}

.border-light {
  border-color: var(--border-color) !important;
}

.bg-light {
  background-color: var(--background) !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .footer {
    text-align: center;
  }
  
  .footer .d-flex {
    justify-content: center !important;
  }
}

/* Focus states for accessibility */
.footer a:focus {
  outline: 2px solid var(--primary-color);
  outline-offset: 2px;
  border-radius: 3px;
}

/* Icon styling */
.footer i {
  width: 16px;
  text-align: center;
}
</style>
